import React from 'react';
import Skeleton from '@alfa-retail-react/components/skeleton';
import classNames from 'classnames';

import { WindowTypeName, windowTypeToClassName } from 'app/utils/useWindowType';
import 'app/component/skeleton/field/FieldSkeleton.less';

export interface FieldSkeletonProps {
    /**
     * Тип окна.
     */
    windowType: WindowTypeName;
    /**
     * CSS класс.
     */
    className?: string;
}

/**
 * Скелетон компонента поля.
 */
export const FieldSkeleton = (props: FieldSkeletonProps) => {
    const className = classNames(
        'fieldSkeleton',
        props.className,
        windowTypeToClassName(props.windowType),
    );

    return <Skeleton className={className} visible animate />;
};
